import React, { useEffect } from 'react';
import cn from 'classnames';

import { Russia } from '@/icons';

import styles from './input.module.scss';

interface IProps {
  className?: string;
  id?: string;
  name?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type: string;
  placeholder?: string;
  autoComplete?: string;
  isValid?: boolean;
  setValid?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EMAIL_REGEXP =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
const PHONE_REGEXP =
  /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/gm;

const Input: React.FC<IProps> = (props) => {
  const {
    className,
    id,
    name,
    type,
    value,
    onChange,
    placeholder,
    autoComplete,
    isValid = true,
    setValid = () => {}
  } = props;

  const inputClassName = cn(styles.input, className, {
    [styles.input_number]: type === 'number',
    [styles.input_error]: !isValid
  });

  useEffect(() => {
    if (value && type === 'email') {
      setValid(EMAIL_REGEXP.test(value));
    }
    if (value && type === 'number') {
      setValid(PHONE_REGEXP.test(value));
    }
  }, [value, type, setValid]);

  return (
    <label className={styles.input__label} htmlFor={id}>
      <input
        id={id}
        className={inputClassName}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        autoComplete={autoComplete}
      />
      {type === 'number' && <Russia className={styles.input__icon} />}
    </label>
  );
};

export default Input;
